import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import LearnMore from './pages/LearnMore';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import DynamicRecordPage from './pages/DynamicRecordPage';
import CertificatesPage from './pages/CertificatesPage';
import VerifyPage from './pages/VerifyPage';
import VerifyRecordPage from './pages/VerifyRecordPage';

export default function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Top accent bar */}
      <Box
        sx={{
          height: '4px',
          background: 'linear-gradient(90deg, #7b3080 0%, #a76fcc 100%)',
        }}
      />

      <Navbar />

      {/* flexGrow pushes the footer to the bottom of the viewport on pages
          shorter than the screen, instead of it floating up under the content. */}
      <Box sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* /certificates browses every issued certificate. /verify looks
              up ONE specific student's credential (diploma or certificate)
              by Record ID — two separate concerns, don't merge them back
              together, see "Diplomas vs Certificates" in CLAUDE.md.
              /verify/:recordId resolves via getCredential() in
              src/data/classes/index.js. */}
          <Route path="/certificates" element={<CertificatesPage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/verify/:recordId" element={<VerifyRecordPage />} />
          {/* Any other top-level path is resolved against classes, then
              certificate types (e.g. /GB250814) — matches production's flat
              URL structure. New classes only need a new data file, see
              src/data/classes/records/. Certificate tracks are listed on
              /certificates instead of getting their own top-level slug, but
              this fallback still resolves one if visited directly. */}
          <Route path="/:slug" element={<DynamicRecordPage />} />
        </Routes>
      </Box>

      <Footer />
    </Box>
  );
}
